import { createFileRoute } from "@tanstack/react-router"
import { CreateDonationPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/finance/donations/pages/create"
)({
  component: function CreateDonationPageRoute() {
    return (
      <AuthorizationGate resource={Resource.DONATION} action={Action.CREATE}>
        <CreateDonationPage />
      </AuthorizationGate>
    )
  },
})
